import React from 'react';
type Bubble = {
  type: 'text';
  from: 'them' | 'me';
  text: string;
} | {
  type: 'voice';
  from: 'them';
  duration: string;
};
type Screenshot = {
  bubbles: Bubble[];
};
const allScreenshots: Screenshot[] = [{
  bubbles: [{
    type: 'text',
    from: 'them',
    text: 'Tengo 47 años y es el primer programa que no me lastima las rodillas. Los videos son clarísimos'
  }]
}, {
  bubbles: [{
    type: 'text',
    from: 'them',
    text: 'Semana 4 terminada. La hinchazón que tenía siempre ya casi no está. Eso sólo ya valió todo 🙌'
  }]
}, {
  bubbles: [{
    type: 'text',
    from: 'them',
    text: 'Pensé que iba a durar 3 días como siempre… y terminé casi todo el programa. No lo puedo creer jajaja'
  }]
}, {
  bubbles: [{
    type: 'text',
    from: 'them',
    text: 'La semana 2 ya noté que la ropa me entraba diferente. No bajé 10 kilos pero me siento muchísimo más liviana'
  }]
}, {
  bubbles: [{
    type: 'voice',
    from: 'them',
    duration: '0:38'
  }, {
    type: 'text',
    from: 'them',
    text: 'Te mandé un audio porque no me alcanzaban las palabras jaja. Gracias en serio 🫶'
  }]
}, {
  bubbles: [{
    type: 'text',
    from: 'them',
    text: 'Ya compré otros programas que no me sirvieron. Este es diferente. Los videos cortos hacen todo fácil, no tenés excusa para no hacerlo'
  }]
}];
export function ForYouSection() {
  return <section className="py-8 bg-white" data-id="element-208">
      <div className="max-w-2xl mx-auto px-4 md:px-6" data-id="element-209">
        <h2 className="font-display text-2xl md:text-3xl text-center text-gray-900 mb-5" data-id="element-210">
          ¿Es para vos?
        </h2>

        <div className="bg-brand-pink-50 border border-brand-pink-100 rounded-2xl p-5 mb-3" data-id="element-211">
          <p className="text-brand-pink-600 font-bold text-xs uppercase tracking-wide mb-3" data-id="element-212">✅ Es para vos si…</p>
          <div className="space-y-2.5" data-id="element-213">
            {['Querés bajar de peso pero el cardio te destruye las rodillas', 'Ya probaste mil dietas y siempre terminás en lo mismo', 'Tenés poco tiempo y necesitás algo corto que puedas sostener', 'Sentís el cuerpo hinchado, pesado y sin energía', 'Querés verte mejor pero sin matarte entrenando'].map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-214">
                <span className="text-emerald-500 font-bold flex-shrink-0" data-id="element-215">✓</span>
                <p className="text-gray-800 text-sm" data-id="element-216">{item}</p>
              </div>)}
          </div>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-5" data-id="element-217">
          <p className="text-gray-400 font-bold text-xs uppercase tracking-wide mb-3" data-id="element-218">❌ No es para vos si…</p>
          <div className="space-y-2.5" data-id="element-219">
            {['Buscás resultados sin hacer nada', 'Querés bajar 10 kilos en una semana', 'No estás dispuesta a dedicar 20 minutos al día'].map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-220">
                <span className="text-rose-400 font-bold flex-shrink-0" data-id="element-221">✗</span>
                <p className="text-gray-500 text-sm" data-id="element-222">{item}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}
export function TestimonialsTease() {
  return <section className="py-8 bg-white" data-id="element-223">
      <div className="max-w-2xl mx-auto px-4 md:px-6" data-id="element-224">
        <p className="text-center text-xs font-bold uppercase tracking-widest text-brand-pink-600 mb-6" data-id="element-225">
          Lo que dicen las que ya lo hicieron
        </p>
        <div className="grid grid-cols-2 gap-4" data-id="element-226">
          {allScreenshots.slice(0, 2).map((screenshot, i) => <ChatScreenshot key={i} screenshot={screenshot} rotate={[-1.2, 1][i]} data-id="element-227" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSection() {
  return <section className="py-12 md:py-16 bg-cream-50 overflow-hidden" data-id="element-228">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-229">
        <div className="text-center mb-10" data-id="element-230">
          <div className="inline-block bg-brand-pink-600 text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide mb-3" data-id="element-231">
            +2.000 mujeres ya empezaron
          </div>
          <h2 className="font-display text-3xl md:text-4xl text-gray-900 mb-3" data-id="element-232">
            Lo que nos escriben las chicas
          </h2>
          <p className="text-gray-600 text-base max-w-xl mx-auto" data-id="element-233">
            Mensajes reales de DM. Sin filtro.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-234">
          {allScreenshots.slice(2).map((screenshot, i) => <ChatScreenshot key={i} screenshot={screenshot} rotate={[-1.5, 1.3, -1, 1.5][i % 4]} data-id="element-235" />)}
        </div>
      </div>
    </section>;
}
function ChatScreenshot({
  screenshot,
  rotate
}: {
  screenshot: Screenshot;
  rotate: number;
}) {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-200 px-4 py-4 space-y-2" style={{
    transform: `rotate(${rotate}deg)`,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif'
  }} data-id="element-236">
      {screenshot.bubbles.map((bubble, idx) => {
      if (bubble.type === 'voice') {
        return <div key={idx} className="flex justify-start" data-id="element-237">
              <div className="flex items-center gap-2 pl-2 pr-3 py-1.5 bg-gray-100 rounded-3xl rounded-bl-md max-w-[85%]" data-id="element-238">
                <button className="w-7 h-7 rounded-full bg-white flex items-center justify-center" data-id="element-239">
                  <svg viewBox="0 0 24 24" className="w-3 h-3 fill-gray-700" data-id="element-240"><path d="M8 5v14l11-7z" data-id="element-241" /></svg>
                </button>
                <div className="flex items-center gap-[2px] h-4" data-id="element-242">
                  {[4, 7, 10, 6, 9, 12, 8, 4, 9, 11, 6, 8, 4, 9, 6].map((h, k) => <span key={k} className="w-[2px] rounded-full bg-gray-400" style={{
                height: `${h}px`
              }} data-id="element-243" />)}
                </div>
                <span className="text-[11px] text-gray-500 tabular-nums" data-id="element-244">{bubble.duration}</span>
              </div>
            </div>;
      }
      return <div key={idx} className="flex justify-start" data-id="element-245">
            <div className="px-3.5 py-2.5 bg-gray-100 text-gray-900 rounded-2xl rounded-bl-md text-[14px] leading-snug max-w-[92%]" data-id="element-246">
              {bubble.text}
            </div>
          </div>;
    })}
    </div>;
}